import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import formValidations from "../../variables/form-validations";
import v2AppService from "../../services/api/v2-app-config-services";
import TimezoneSelect, { i18nTimezones } from "react-timezone-select";
import { useHistory } from "react-router-dom";
import UserContext from "../../UserContext";
// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    Label,
    FormGroup,
    Form,
    Input,
    Alert,
    Spinner,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Container,
    Row,
    Col,
} from "reactstrap";

import Select from "react-select";
import { create } from "lodash";
import SaveAppTemmplate from './Customization/SaveNewTemplate';

const CreateAppTemplate = (props) => {

     const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const platform = searchParams.get('platform');

    const history = new useHistory();
    const [formdetails, setFormDetails] = useState({
        name: "",
        description: "",
        template_id: "",
        platform:platform,
    });
    const context = useContext(UserContext);
    const [existingTemplates, setExistingTemplates] = useState(false);
    const [templateNameState, setTemplateNameState] = useState("");
    const [templateNameError, setTemplateNameError] = useState(false);
    const [description, setDescription] = useState(false);
    const [descriptionError, setDescriptionError] = useState(false);

    const [showLoader, setShowLoader] = useState(false);
    const [showSaveButton, setShowSaveButton] = useState(true);
    const [alert, setAlert] = useState({ show: false, message: "", type: "" });

    const [template, setTemplate] = useState(false);
    const [templateOptions, setTemplateOptions] = useState(false);

   

    useEffect(() => {
        (async () => {
            const defaultTemplateOption = { value: "custom-template", label: "Custom Template" };
            const defaultTemplateOptions = [defaultTemplateOption];

            let templateOptions = [...defaultTemplateOptions];
            let fetchedTemplates = [];

            try {
                const response = await v2AppService.getAppTemplates(platform);

                if (response?.status && Array.isArray(response.data)) {
                    fetchedTemplates = response.data;

                    const mappedTemplates = fetchedTemplates.map(template => ({
                        value: template._id,
                        label: template.name,
                    }));

                    templateOptions = [defaultTemplateOption, ...mappedTemplates];
                } else {
                    console.log("getAppTemplates returned invalid status or data format:", response);
                }
            } catch (error) {
                console.log("Exception while fetching templates:", error);
            } finally {
                const selectedTemplate = templateOptions[0];

                setTemplate(selectedTemplate);
                setFormDetails(prevDetails => ({
                    ...prevDetails,
                    template_id: selectedTemplate.value,
                }));
                setTemplateOptions(templateOptions);
                setExistingTemplates(fetchedTemplates);

                console.log("Template options applied:", templateOptions);
            }
        })();
    }, []);



    const handleChange = (event) => {
        setFormDetails({
            ...formdetails,
            [event.target.id]: event.target.value.trim(),
        });
    };

    const changeTemplate = (event) => {
        setFormDetails({
            ...formdetails,
            template_id: event.value,
        });
        setTemplate(event);
    };


    const validateTemplateName = () => {
        if (formdetails.name === "") {
            setTemplateNameState("has-danger");
            setTemplateNameError("Name is required");
            return false;
        }

        if (existingTemplates) {
            let duplicateName = false;
            Object.keys(existingTemplates).forEach(function (key) {
                let existingTemplateName = existingTemplates[key].name;
                if (formdetails.name === existingTemplateName) {
                    duplicateName = true;
                }
            });
            if (duplicateName) {
                setTemplateNameState("has-danger");
                setTemplateNameError("You have already created template with this name.");
                return false;
            }
        }

        setTemplateNameState("has-success");
        return true;
    };


    const handleSubmit = function (e) {
        validateForm();
        e.preventDefault();
    };

    const validateForm = async () => {
        let namevalidation = validateTemplateName();
        if (namevalidation) {
            setShowLoader(true);
            setShowSaveButton(false);
            let createTemplate = await v2AppService.createAppTemplate(formdetails);
            if (!createTemplate?.status && createTemplate?.error?.errorCode === 403) {
                context.setIsAuthorized(context);
            }
            else if (createTemplate.status) {
                setTimeout(() => {
                    setShowLoader(false)
                    setAlert({ show: true, type: 'success', message: 'Template was created Successfully' });
                }, 1000);
                setTimeout(() => {
                    setAlert({ show: false, type: '', message: '' });
                }, 3000);
                setTimeout(() => {
                    history.push("/template/v2-app-template/list");
                }, 2000);
            } else {
                setTimeout(() => {
                    setShowLoader(false)
                    setShowSaveButton(true)
                    setAlert({ show: true, type: 'danger', message: 'Template could not be created, Please try again.' });
                }, 1000);
                setTimeout(() => {
                    setAlert({ show: false, type: '', message: '' });
                }, 3000);
            }
        }
    };
    console.log("in create template page of v2 app")
    return (
        <div className="content">
            <Container>
                <Row>
                    <Col className="ml-auto mr-auto" md="12">
                        <Card className="card-signup text-center">
                            <CardHeader>
                                <CardTitle tag="h4">Create App Template</CardTitle>
                            </CardHeader>
                            <CardBody>
                                <Form
                                    className="form-horizontol form"
                                    action=""
                                    id="createTemplate"
                                    method="POST"
                                    onSubmit={handleSubmit}
                                >
                                    <Row>
                                        <Label sm="2">Name <span class="text-danger"> * </span></Label>
                                        <Col sm="7">
                                            <FormGroup
                                                className={templateNameState}
                                            >
                                                <Input
                                                    name="name"
                                                    id="name"
                                                    type="text"
                                                    onChange={handleChange}

                                                />
                                                {templateNameState ===
                                                    "has-danger" ? (
                                                    <label className="error">
                                                        {templateNameError}
                                                    </label>
                                                ) : null}
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Label sm="2">Description</Label>
                                        <Col sm="7">
                                            <FormGroup className={description}>
                                                <Input
                                                    name="description"
                                                    id="description"
                                                    type="textarea"
                                                    onChange={handleChange}
                                                />
                                                {description ===
                                                    "has-danger" ? (
                                                    <label className="error">
                                                        {descriptionError}
                                                    </label>
                                                ) : null}
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Label sm="2">
                                            Copy From Templates <span class="text-danger"> * </span>
                                        </Label>
                                        <Col sm="7">
                                            <FormGroup>
                                                <Select
                                                    className="react-select primary"
                                                    classNamePrefix="react-select"
                                                    name="select-template"
                                                    value={template}
                                                    onChange={changeTemplate}
                                                    options={templateOptions}
                                                />

                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    {
                                        formdetails.template_id !== "custom-template" ?
                                            showSaveButton ? (
                                                <Button
                                                    className="btn-round"
                                                    color="info"
                                                    type="button"
                                                    onClick={validateForm}
                                                >
                                                    Create
                                                </Button>
                                            ) : (
                                                ""
                                            )
                                            : null
                                    }
                                    {alert.show ? (
                                        <Alert color={alert.type}>
                                            {alert.message}
                                        </Alert>
                                    ) : (
                                        ""
                                    )}

                                    {showLoader ? (
                                        <Spinner
                                            animation="border"
                                            role="status"
                                        >
                                            <span className="sr-only">
                                                Loading...
                                            </span>
                                        </Spinner>
                                    ) : (
                                        ""
                                    )}
                                </Form>
                            </CardBody>
                            <CardFooter></CardFooter>
                        </Card>
                    </Col>
                </Row>
            </Container>


            {
                formdetails.template_id === "custom-template" ?
                    <SaveAppTemmplate formData={formdetails} />
                    : null
            }
        </div>
    );
};

export default CreateAppTemplate;

